import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
const dialogMode = ()=>import(/* webpackChunkName: "standalone-dialog" */ '@/standalone/dialogMode/dialogMode.vue')
Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name:'Home',
      component: dialogMode
    },
  ]
})
// 全局前置守卫 - 开始加载
router.beforeEach((to, from, next) => {
  // 显示全局 loading
  store.commit('set_global_loading', true)
  next()
})

// 全局后置守卫 - 加载完成
router.afterEach(() => {
  // 隐藏全局 loading
  store.commit('set_global_loading', false)
})

export default router